/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Pause_TitleInputs */

const en_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Be Right Back!`)
};

const ar_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`!سأعود فوراً`)
};

const de_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bin gleich zurück!`)
};

const es_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Ya vuelvo!`)
};

const fr_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je reviens tout de suite !`)
};

const it_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torno subito!`)
};

const ja_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すぐに戻ります！`)
};

const ko_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`금방 돌아올게요!`)
};

const pt_br_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volto logo!`)
};

const ru_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я скоро вернусь!`)
};

const th_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เดี๋ยวมานะ!`)
};

const tr_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemen döneceğim!`)
};

const zh_cn_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`马上回来！`)
};

const zh_tw_dialog_event_pause_title = /** @type {(inputs: Dialog_Event_Pause_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`馬上回來！`)
};

/**
* | output |
* | --- |
* | "Be Right Back!" |
*
* @param {Dialog_Event_Pause_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_pause_title = /** @type {((inputs?: Dialog_Event_Pause_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Pause_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_pause_title(inputs)
	if (locale === "ar") return ar_dialog_event_pause_title(inputs)
	if (locale === "de") return de_dialog_event_pause_title(inputs)
	if (locale === "es") return es_dialog_event_pause_title(inputs)
	if (locale === "fr") return fr_dialog_event_pause_title(inputs)
	if (locale === "it") return it_dialog_event_pause_title(inputs)
	if (locale === "ja") return ja_dialog_event_pause_title(inputs)
	if (locale === "ko") return ko_dialog_event_pause_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_pause_title(inputs)
	if (locale === "ru") return ru_dialog_event_pause_title(inputs)
	if (locale === "th") return th_dialog_event_pause_title(inputs)
	if (locale === "tr") return tr_dialog_event_pause_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_pause_title(inputs)
	return zh_tw_dialog_event_pause_title(inputs)
});